module.exports = __webpack_public_path__ + "static/media/scroll6.e99f8db1.jpg";